import { render, staticRenderFns } from "./TripleView.vue?vue&type=template&id=5301639a&"
import script from "./TripleView.vue?vue&type=script&lang=ts&"
export * from "./TripleView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports